import { useMutation } from '@tanstack/react-query';
import * as api from 'util/api';

export default ({ onSuccess, onError, onSettled } = {}) => useMutation({
  mutationKey: ['segmentation', 'reject-run'],
  mutationFn: (runId) => api.rejectSegmentationRun(runId),
  onSuccess,
  onError,
  onSettled,
});
